"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminProvider = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const lodash_1 = require("lodash");
const admin_console_1 = require("../../modules/admin/console/admin-console");
const admin_reindex_1 = require("../../modules/admin/reindex/admin-reindex");
const messages_1 = require("../../modules/admin/soap/logger/message/messages");
const menubar_context_1 = require("../../composite/menubar/menubar-context");
const navigation_context_1 = require("../../composite/navigation/navigation-context");
const user_context_1 = require("../user/user-context");
const web_socket_context_1 = require("../web-socket/web-socket-context");
const admin_context_1 = require("./admin-context");
function AdminProvider({ permission, prefix, reindexUrl, soapMessagesUrl, showReindex = true, showConsole = true, showSoapMessages = true, }) {
    const { modifyItems } = (0, react_1.useContext)(menubar_context_1.MenubarContext);
    const { navigate } = (0, react_1.useContext)(navigation_context_1.NavigationContext);
    const { hasPermission } = (0, react_1.useContext)(user_context_1.UserContext);
    const { isWsActive } = (0, react_1.useContext)(web_socket_context_1.WebsocketContext);
    const defaultReindexUrl = `${prefix}/admin/reindex`;
    const defaultConsoleUrl = `${prefix}/admin/console`;
    const defaultSoapMessagesUrl = `${prefix}/admin/soap/logger/messages`;
    const reindexCondition = reindexUrl !== undefined && showReindex;
    const consoleCondition = isWsActive && showConsole;
    const soapMessagesCondition = soapMessagesUrl !== undefined && showSoapMessages;
    const menuItems = (0, react_1.useMemo)(() => {
        if (reindexCondition || consoleCondition || soapMessagesCondition) {
            return [
                {
                    label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_DEVTOOLS", defaultMessage: "V\u00FDvojov\u00E9 n\u00E1stroje" })),
                    isActive: (pathname) => {
                        return [
                            defaultReindexUrl,
                            defaultConsoleUrl,
                            defaultSoapMessagesUrl,
                        ].includes(pathname);
                    },
                    items: (0, lodash_1.compact)([
                        reindexCondition && {
                            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_REINDEX", defaultMessage: "Reindex" })),
                            onClick: () => {
                                navigate(defaultReindexUrl);
                            },
                            href: defaultReindexUrl,
                        },
                        consoleCondition && {
                            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_CONSOLE", defaultMessage: "Konzole" })),
                            onClick: () => {
                                navigate(defaultConsoleUrl);
                            },
                            href: defaultConsoleUrl,
                        },
                        soapMessagesCondition && {
                            label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_SOAP_MESSAGES", defaultMessage: "SOAP komunikace" })),
                            onClick: () => {
                                navigate(defaultSoapMessagesUrl);
                            },
                            href: defaultSoapMessagesUrl,
                        },
                    ]),
                },
            ];
        }
        else {
            return [];
        }
    }, [
        consoleCondition,
        defaultConsoleUrl,
        defaultReindexUrl,
        defaultSoapMessagesUrl,
        navigate,
        reindexCondition,
        soapMessagesCondition,
    ]);
    const allowed = hasPermission(permission);
    // adds items to menu
    (0, react_1.useEffect)(() => {
        if (allowed) {
            modifyItems((items) => [...items, ...menuItems]);
        }
        return () => {
            if (allowed) {
                modifyItems((items) => items.filter((item) => !menuItems.includes(item)));
            }
        };
    }, [menuItems, modifyItems, allowed]);
    return (react_1.default.createElement(admin_context_1.AdminContext.Provider, { value: {
            reindexUrl: reindexUrl,
            soapMessagesUrl: soapMessagesUrl,
        } },
        react_1.default.createElement(react_router_dom_1.Switch, null,
            reindexCondition && (react_1.default.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/reindex`, component: admin_reindex_1.AdminReindex })),
            consoleCondition && (react_1.default.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/console`, component: admin_console_1.AdminConsole })),
            soapMessagesCondition && (react_1.default.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/soap/logger/messages/:id?`, component: messages_1.SoapMessages })))));
}
exports.AdminProvider = AdminProvider;
//# sourceMappingURL=admin-provider.js.map